import { render } from "./ListTickets.vue?vue&type=template&id=10baf441&scoped=true"
import script from "./ListTickets.vue?vue&type=script&lang=js"
export * from "./ListTickets.vue?vue&type=script&lang=js"

import "./ListTickets.vue?vue&type=style&index=0&id=10baf441&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10baf441"]])

export default __exports__